import { render, staticRenderFns } from "./anaysis.vue?vue&type=template&id=8d27bb2c&scoped=true"
import script from "./anaysis.vue?vue&type=script&lang=js"
export * from "./anaysis.vue?vue&type=script&lang=js"
import style0 from "./anaysis.vue?vue&type=style&index=0&id=8d27bb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d27bb2c",
  null
  
)

export default component.exports